import React, { useEffect } from 'react';

import { colors, layout } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';

import { Container, Header, Anchor } from 'Components/core';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { SubHeader, TitleHeader } from 'Components/core/Header';

export default  ()=>{
  
  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_MEM);
  },[]);
  
  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        let resources = state.moreEnrollmentMaterials?.resource;

        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <TitleHeader>More
              <SubHeader> enrollment materials</SubHeader>
            </TitleHeader>
      
            {resources.map(material => (
              <Container seperation="16px" style={{ color: colors.accent }}>
                <FontAwesomeIcon icon={faFile} />
                <Anchor code={CODES.MR_ENROLL_MAT_LINK} to={material.url} style={{ alignSelf: 'flex-start' }}>
                  {material.label}
                </Anchor>
              </Container>
            ))}
          </Container>
        );
      }}
    </Subscribe>
  );
};
